// Libraries
import { useTranslation } from "react-i18next";

// Components
import { Button, CircularProgress, Divider, Typography } from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import { GridFooterContainer, GridPagination } from "@mui/x-data-grid";

const PatientTableFooter = ({
  canSearchMore,
  handleSearchMore,
  loading,
  hasResults,
}) => {
  const { t } = useTranslation();
  const handleButtonClick = (event) => {
    event.stopPropagation();
    handleSearchMore?.();
  };

  return (
    <GridFooterContainer sx={{ display: "block" }}>
      {canSearchMore && (
        <Button
          variant="text"
          size="large"
          fullWidth
          onMouseDown={(event) => event.stopPropagation()}
          onClick={handleButtonClick}
          disabled={loading}
          endIcon={!loading ? <ExpandMore /> : null}
          startIcon={
            loading ? <CircularProgress size={18} color="inherit" /> : null
          }
          sx={{
            color: "primary.main",
            fontWeight: "700",
            textTransform: "none",
            borderRadius: 0,
            py: 2,
          }}
        >
          {loading
            ? t("mbsSearch.searchingMoreResults")
            : t("mbsSearch.searchMoreResults")}
        </Button>
      )}
      {!canSearchMore && !loading && hasResults && (
        <Typography
          variant="body2"
          color="text.secondary"
          textAlign="center"
          py={2}
        >
          {t("mbsSearch.allResultsShown")}
        </Typography>
      )}
      <Divider />
      <GridPagination />
    </GridFooterContainer>
  );
};

export default PatientTableFooter;
